
export type StreamingInfoResponseSupportedDevicesItem = typeof StreamingInfoResponseSupportedDevicesItem[keyof typeof StreamingInfoResponseSupportedDevicesItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StreamingInfoResponseSupportedDevicesItem = {
  browser: 'browser',
  mobile: 'mobile',
  smarttv: 'smarttv',
} as const;
